module.exports = __webpack_public_path__ + "img/ZA.df1a1208.png";